import { put, select, takeLatest } from 'redux-saga/effects'
import { randomNumber } from '../../../utilities'
import { PatientDemographicsConstants } from '../store/patientDemographics.constants'
import { IPatientDemographicsState } from '../store/patientDemographics.types'
import { getPatientDemographicsSelector } from '../selectors'
import { addPhysicianList, clearPhysicianData, savePatientDemographics } from '../store/patientDemographics.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* addPhysicianInformation() {
  const physicianInformation: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
  const { physicianDataList, physicianData } = physicianInformation
  const { physicianFirstName, physicianLastName, key } = physicianData
  try {
    const copyPhysicianDataList = [...physicianDataList]
    if ((physicianFirstName && physicianFirstName.trim()) || (physicianLastName && physicianLastName.trim())) {
      const selectedPhysiciansIndex = physicianDataList.findIndex((insuranceInfo) => insuranceInfo.key === key)
      if (selectedPhysiciansIndex >= 0) {
        copyPhysicianDataList[selectedPhysiciansIndex] = physicianData
      } else {
        copyPhysicianDataList.push({ ...physicianData, key: randomNumber().toString() })
      }
    }
    yield put(addPhysicianList(copyPhysicianDataList))
    yield put(clearPhysicianData())
    yield put(savePatientDemographics())
  } catch (e) {
    yield put(throwPcrException(`addPhysicianInformation() error: ${e}`))
  }
}

export function* addPhysicianInformationSaga() {
  yield takeLatest([PatientDemographicsConstants.ADD_PHYSICIAN_DATA], addPhysicianInformation)
}
